import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/close_btn.png'


const _hoisted_1 = { class: "popup" }
const _hoisted_2 = { class: "detail-popup" }
const _hoisted_3 = { class: "popup-header" }
const _hoisted_4 = { class: "popup-body" }
const _hoisted_5 = { class: "contents_body" }
const _hoisted_6 = { class: "contract_table" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "popup-footer" }

import { ref, onMounted } from 'vue';

import UploadContractPop from '@/components/popup/UploadContractPop.vue';
import announceAPI from '@/api/announceAPI';
import { Contract, saveFile } from "@/common/types";
import { convertDateTime } from '@/utils/utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContractListPop',
  props: {
    공고순번: {},
    회원구분: {}
  },
  emits: ["closePopup","openContractPop"],
  setup(__props: any, { emit: __emit }) {

// ...existing code...
const emit = __emit;
const uploadContractFlag = ref(false);
const uploadContractClose = () => {
  uploadContractFlag.value = false;
  getContractList()
}
// 예시 데이터
const props = __props;
const contractList = ref<Contract[]>([
  {
    계약서순번: 1,
    수주계약서작성여부: true,
    수행계약서작성여부: true,
    저장파일: {} as saveFile,
    작성일시: ''
  },
  {
    계약서순번: 1,
    수주계약서작성여부: true,
    수행계약서작성여부: true,
    저장파일: {} as saveFile,
    작성일시: ''
  }
]);
onMounted(() => {
  getContractList()
});
const getContractList = async () => {
  await announceAPI.contractList(props.공고순번).then((res) => {
    contractList.value = res.data.data;
  });
};
const readContract = (data: Contract) => {
  emit("openContractPop", data);
};
const confirmSelection = (flag: boolean) => {
  if(flag) {
    uploadContractFlag.value = true
  } else {
    emit("closePopup", { popupType: "contractList", refresh: flag });
  }
};
const deleteContract = async (data: Contract) => {
  if(data.수주계약서작성여부 && data.수행계약서작성여부) return;
  if (!confirm("작성중인 계약서를 삭제하시겠습니까?")) return;
  await announceAPI.deleteContract(props.공고순번, data.계약서순번).then(() => {
    alert("계약서가 삭제되었습니다.");
    getContractList()
  });
}
// ...existing code...

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "popup_cover" }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "popup_title" }, "계약이력", -1)),
          _createElementVNode("img", {
            src: _imports_0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (confirmSelection(false))),
            class: "close_icon"
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("table", _hoisted_6, [
              _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "등록일시"),
                  _createElementVNode("th", null, "파일명"),
                  _createElementVNode("th", null, "비고"),
                  _createElementVNode("th"),
                  _createElementVNode("th")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contractList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(_unref(convertDateTime)(item.등록일시)), 1),
                    _createElementVNode("td", null, _toDisplayString(item.저장파일.원파일명), 1),
                    _createElementVNode("td", null, _toDisplayString(item.비고), 1),
                    _createElementVNode("td", {
                      onClick: ($event: any) => (readContract(item))
                    }, _toDisplayString(item[`${props.회원구분}계약서작성여부`] ? '보기' : '날인'), 9, _hoisted_7),
                    _createElementVNode("td", {
                      onClick: ($event: any) => (deleteContract(item))
                    }, _toDisplayString(item.수주계약서작성여부 && item.수행계약서작성여부 ? '' : '삭제'), 9, _hoisted_8)
                  ]))
                }), 128)),
                (contractList.value.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_9, _cache[3] || (_cache[3] = [
                      _createElementVNode("td", { colspan: "5" }, "등록된 계약이력이 없습니다.", -1)
                    ])))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            class: "popup_confirm_btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (confirmSelection(true)))
          }, _toDisplayString(contractList.value.length === 0 ? '최초':'변경') + "계약 등록", 1)
        ])
      ])
    ]),
    (uploadContractFlag.value)
      ? (_openBlock(), _createBlock(UploadContractPop, {
          key: 0,
          onClosePopup: uploadContractClose,
          공고순번: props.공고순번
        }, null, 8, ["공고순번"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})